import { GetFixFeatureResponse } from './api-services/get-fix-feature.service';

/**
 * 固定特集一覧画面の値を管理するクラス
 * @export KYMW4501Model
 * @class KYMW4501Model
 */
export class KYMW4501Model {
  public fixedSpecialFeatureList: Array<any> = [];
  public mediumType: string;
  public featureCode: string;

  /**
   * サーバから取得したデータを表示する
   * @param GetFixFeatureResponse data
   * @memberof KYMW4501Model
   */
  public setFixedSpecialFeatureList(respponse: GetFixFeatureResponse[]): void {
    this.fixedSpecialFeatureList = respponse.map(_ => {
      return {
        mediumType: _.MediumType,
        mediumName: _.MediumName,
        featureCode: _.FeatureCode,
        sequenceCode: _.SeaqenceCode,
        featureName: _.FeatureName
      }
    })
  }
}
